import { useTranslation } from "react-i18next";
import { useAreaCrumbs } from "@/components/areaCrumbs";
import { PageBreadcrumbs } from "@/components/PageBreadcrumbs";
import { Text } from "@/components/Text";
import { useAdminCanEdit } from "../useAdminCanEdit";
import { NewUserForm } from "./NewUserForm";

/** /admin/users/new: a full page, not a modal (docs/design/web/WEB_ADMIN_DESIGN.md decision 4). */
export function NewUserPage() {
  const { t } = useTranslation("admin");
  const areas = useAreaCrumbs();
  const canEdit = useAdminCanEdit();
  return (
    <div className="flex flex-col">
      <PageBreadcrumbs
        trail={[areas.admin, { label: t("users.title"), to: "/admin/users" }]}
        current={t("users.add")}
      />
      <div className="mx-auto flex w-full max-w-2xl flex-col gap-6 px-4 py-6 md:px-8">
        {canEdit ? <NewUserForm /> : <Text tone="secondary">{t("readOnlyMobile")}</Text>}
      </div>
    </div>
  );
}
